import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: "My skin is already the best it's been in months.",
    name: 'Mo W.'
  }, {
    quote: "She makes me feel safe, confident, and loved. I won't let anyone else touch my face!",
    name: 'Jillian H.'
  }, {
    quote: 'People ask me on a daily about my glowing skin! 10/10 recommend for everything.',
    name: 'Jennifer J.'
  }];
  return <section className="relative py-20 md:py-28 bg-[#0A0A0A] overflow-hidden" style={{
    backgroundImage: 'radial-gradient(circle at center, rgba(200,168,78,0.05) 0%, rgba(10,10,10,1) 70%)',
    backgroundAttachment: 'fixed'
  }} data-id="element-179">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <span className="text-[#C8A84E] text-sm tracking-[0.2em] uppercase font-semibold mb-4 block" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-182">
            What Our Clients Say
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-white leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-183">
            The #RaiseTheBarBabes Experience
          </h2>
        </div>

        <div className="flex overflow-x-auto snap-x snap-mandatory gap-6 pb-8 md:grid md:grid-cols-3 md:overflow-visible hide-scrollbar" data-id="element-184">
          {testimonials.map((testimonial, index) => <div key={index} className="min-w-[300px] md:min-w-0 snap-center bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 flex flex-col relative" data-id="element-185">
              <div className="text-[#C8A84E] text-6xl font-serif absolute top-4 left-6 opacity-40 leading-none" data-id="element-186">
                "
              </div>

              <div className="flex gap-1 mb-6 relative z-10 mt-4" data-id="element-187">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#C8A84E] text-[#C8A84E]" data-id="element-188" />)}
              </div>

              <p className="text-white/90 italic mb-8 flex-grow relative z-10 text-lg" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-189">
                "{testimonial.quote}"
              </p>

              <p className="text-[#C8A84E] font-semibold" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-190">
                — {testimonial.name}
              </p>
            </div>)}
        </div>

        <div className="text-center mt-8" data-id="element-191">
          <p className="text-gray-400 text-sm" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-192">
            4.9 Stars · 600+ Reviews on Groupon
          </p>
        </div>
      </div>
    </section>;
}